export class CurrentSubscription {
  constructor(data = {}) {
    this.state = data.status;
    this.startPeriod = data.current_period_start;
    this.endPeriod = data.current_period_end;
  }
}
